import React, { memo } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { FilterRouter } from 'app/components';
import { useFlags } from 'app/flagsmith';
import { featureFlags, isFeatureEnabled } from 'app/flagsmith/features';
import { NotFoundPage } from 'components/NotFoundPage';
import { ActiveCloudResource } from 'containers/ActiveCloudResource';
import { AllowList } from 'containers/Inventory/AllowList/Loadable';
import { allowListSaga } from 'containers/Inventory/AllowList/saga';
import * as allowListSlice from 'containers/Inventory/AllowList/slice';
import { InventoryV3Page } from 'containers/Inventory/CloudInventory/InventoryV3Page';
import { LegacyCloudInventoryPage } from 'containers/Inventory/CloudInventory/LegacyCloudInventoryPage';
import { InventoryContext } from 'containers/Inventory/InventoryContext/Loadable';
import { inventoryContextSaga } from 'containers/Inventory/InventoryContext/saga';
import * as contextSlice from 'containers/Inventory/InventoryContext/slice';
import { SoftwareInventory } from 'containers/Inventory/SoftwareInventory/Loadable';
import { useInjector } from 'utils/inject';

export const Inventory = memo(() => {
  const { inventory_v3_features: inventoryV3Features } = useFlags([
    featureFlags.inventoryV3,
  ]);
  const isNewInventoryEnabled = isFeatureEnabled(inventoryV3Features);
  useInjector(
    contextSlice.sliceKey,
    contextSlice.reducer,
    inventoryContextSaga,
  );
  useInjector(allowListSlice.sliceKey, allowListSlice.reducer, allowListSaga);

  return (
    <Routes>
      {/*<Route index element={<Navigate to="cloud" replace />} />*/}
      <Route element={<FilterRouter path="/inventory/cloud" />}>
        <Route
          path="cloud"
          index
          element={
            isNewInventoryEnabled ? (
              <InventoryV3Page key="inventory-v3" />
            ) : (
              <LegacyCloudInventoryPage key="legacy" />
            )
          }
        />
      </Route>
      <Route element={<FilterRouter path="/inventory/software" />}>
        <Route
          path="software"
          element={
            isNewInventoryEnabled ? <SoftwareInventory /> : <NotFoundPage />
          }
        />
      </Route>
      <Route
        element={
          <FilterRouter path="/inventory/cloud/resource/:resource_type/:id" />
        }
      >
        <Route
          path="cloud/resource/:resource_type/:id"
          element={<ActiveCloudResource />}
        />
      </Route>
      <Route element={<FilterRouter path="/inventory/allowlist" />}>
        <Route path="allowlist/*" element={<AllowList />} />
      </Route>
      <Route element={<FilterRouter path="/inventory/context" />}>
        <Route path="context/*" element={<InventoryContext />} />
      </Route>
    </Routes>
  );
});
